import { render } from "./ClinicsPatientSearch.vue?vue&type=template&id=8040a468&scoped=true&lang=pug"
import script from "./ClinicsPatientSearch.vue?vue&type=script&lang=js"
export * from "./ClinicsPatientSearch.vue?vue&type=script&lang=js"

import "./ClinicsPatientSearch.vue?vue&type=style&index=0&id=8040a468&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8040a468"]])

export default __exports__